import {
  startNodeTriggerLabel,
  StartNodeTrigger
} from 'Automations/nodeDefinitions/definitions/start'
import { useAvailableTriggerTypes } from '../useAvailableTriggerTypes'

export const useStartNodeTriggerOptions = (): Array<{
  value: StartNodeTrigger
  label: string
}> => {
  const availableTriggers = useAvailableTriggerTypes()

  return availableTriggers
    .filter(
      (trigger): trigger is StartNodeTrigger => trigger in startNodeTriggerLabel
    )
    .map(trigger => ({
      value: trigger,
      label: startNodeTriggerLabel[trigger]
    }))
}
